module.exports = __webpack_public_path__ + "static/media/opisanie.6d52b0a9.pdf";